import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const RECEIPT_API_URL = `${API_HOST}/api/receipt`;

function* createReceiptTool() {
  yield takeEvery(actions.CREATE_RECEIPT_TOOL, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${RECEIPT_API_URL}/tool`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_RECEIPT_TOOL_ENDED });
    }
  });
}

function* searchReceiptTools() {
  yield takeEvery(actions.SEARCH_RECEIPT_TOOLS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${RECEIPT_API_URL}/tool?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_RECEIPT_TOOLS_ENDED });
    }
  });
}

function* updateReceiptTool() {
  yield takeEvery(actions.UPDATE_RECEIPT_TOOL, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${RECEIPT_API_URL}/tool`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_RECEIPT_TOOL_ENDED });
    }
  });
}

function* searchReceipts() {
  yield takeEvery(actions.SEARCH_RECEIPTS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${RECEIPT_API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_RECEIPTS_ENDED });
    }
  });
}

function* searchReceiptIssuedRecords() {
  yield takeEvery(actions.SEARCH_RECEIPT_ISSUED_RECORDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${RECEIPT_API_URL}/issuedRecord?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_RECEIPT_ISSUED_RECORDS_ENDED });
    }
  });
}

function* searchCredits() {
  yield takeEvery(actions.SEARCH_CREDITS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${RECEIPT_API_URL}/credit?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_CREDITS_ENDED });
    }
  });
}

function* searchCreditAllowanceRecords() {
  yield takeEvery(actions.SEARCH_CREDIT_ALLOWANCE_RECORDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${RECEIPT_API_URL}/credit/allowanceRecord?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_CREDIT_ALLOWANCE_RECORDS_ENDED });
    }
  });
}

function* updateReceiptIfInit() {
  yield takeEvery(actions.UPDATE_RECEIPT_IF_INIT, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${RECEIPT_API_URL}/query`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_RECEIPT_IF_INIT_ENDED });
    }
  });
}

function* issueReceiptIfUnprocessedOrFailed() {
  yield takeEvery(actions.ISSUE_RECEIPT_IF_UNPROCESSED_OR_FAILED, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${RECEIPT_API_URL}/issue`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.ISSUE_RECEIPT_IF_UNPROCESSED_OR_FAILED_ENDED });
    }
  });
}

function* updateReceiptIfInvalidationInit() {
  yield takeEvery(actions.UPDATE_RECEIPT_IF_INVALIDATION_INIT, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${RECEIPT_API_URL}/invalidate`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_RECEIPT_IF_INVALIDATION_INIT_ENDED });
    }
  });
}

function* updateCreditIfInit() {
  yield takeEvery(actions.UPDATE_CREDIT_IF_INVALIDATION_INIT, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${RECEIPT_API_URL}/issueCredit`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_CREDIT_IF_INVALIDATION_INIT_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createReceiptTool),
    fork(searchReceiptTools),
    fork(updateReceiptTool),
    fork(searchReceipts),
    fork(searchReceiptIssuedRecords),
    fork(searchCredits),
    fork(searchCreditAllowanceRecords),
    fork(updateReceiptIfInit),
    fork(issueReceiptIfUnprocessedOrFailed),
    fork(updateReceiptIfInvalidationInit),
    fork(updateCreditIfInit),
  ]);
}
